// TODO andrew jackson refactor
import type { AppKitNetwork } from '@reown/appkit/networks';
import { createAppKit } from '@reown/appkit/vue';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import type { Config } from '@wagmi/core';
import { http } from 'viem';
import type { Chain as ApiChain } from '@rs/spec-app-api';

// Project id нужен только WalletConnect-релею (QR-подключение мобильных кошельков);
// RPC от него не зависят — транспорты бьют напрямую в rpcUrl сетей с бэка.
const projectId = import.meta.env.VITE_REOWN_PROJECT_ID ?? 'placeholder';
const appOrigin = import.meta.env.VITE_APP_URL?.replace(/\/$/, '') ?? globalThis.location.origin;

const metadata = {
	name: 'RStake',
	description: 'DeFi yield aggregator',
	url: appOrigin,
	icons: [`${appOrigin}/main_logo_app.png`],
};

/** Присваивается в initWeb3 до mount — see main.ts; live binding для потребителей. */
export let wagmiConfig: Config;

function toAppKitNetwork(chain: ApiChain): AppKitNetwork {
	return {
		id: chain.id,
		name: chain.name,
		nativeCurrency: {
			name: chain.nativeCoin.name,
			symbol: chain.nativeCoin.symbol,
			decimals: chain.nativeCoin.decimals,
		},
		rpcUrls: { default: { http: [chain.rpcUrl] } },
		...(chain.explorerUrl ? { blockExplorers: { default: { name: chain.name, url: chain.explorerUrl } } } : {}),
	};
}

/**
 * Сети не захардкожены: приходят ручкой listChains (вместе с публичным rpcUrl) —
 * локальный стенд отдаёт anvil, прод — testnet'ы, без пересборки фронта.
 */
export function initWeb3(chains: ApiChain[]): void {
	const [first, ...rest] = chains.map((chain) => toAppKitNetwork(chain));
	if (!first) {
		throw new Error('web3 init failed: API returned no active chains');
	}
	const networks: [AppKitNetwork, ...AppKitNetwork[]] = [first, ...rest];

	const wagmiAdapter = new WagmiAdapter({
		networks,
		projectId,
		// Явные транспорты — иначе адаптер ходит через Reown blockchain API,
		// который без валидного project id отвечает ошибками на все RPC-вызовы.
		transports: Object.fromEntries(chains.map((chain) => [chain.id, http(chain.rpcUrl)])),
	});

	wagmiConfig = wagmiAdapter.wagmiConfig;

	createAppKit({
		adapters: [wagmiAdapter as never],
		networks,
		projectId,
		metadata,
		enableNetworkSwitch: false,
		features: {
			analytics: false,
			email: false, // опционально — убрать email/socials из модалки
			socials: false,
		},
	});
}
